import { QualityIssueType, CountrySpecificLabelIssue, LabelError, MaterialDisposition } from '../../../../enums';

export interface IQualitySubtypeInt {
    issueType: QualityIssueType;
    countrySpecificLabelMissing?: CountrySpecificLabelIssue;
    labelError?: LabelError;
    materialDisposition: MaterialDisposition;
}
